/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Artifact_Landing_Start_ConversationInputs */



/**
* | output |
* | --- |
* | "Start conversation" |
*
* @param {Artifact_Landing_Start_ConversationInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const artifact_landing_start_conversation = /** @type {((inputs?: Artifact_Landing_Start_ConversationInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifact_Landing_Start_ConversationInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Unterhaltung starten")
	return /** @type {LocalizedString} */ ("Start conversation")
});